// extracted by mini-css-extract-plugin
export default {"icon":"TemplateIcon-module__icon--Sf9lL"};